package app.nestbridge.domain.ping.api

import com.karawek.core.network.AuthMode
import com.karawek.core.network.AuthModeAttributeKey
import app.nestbridge.domain.ping.model.HttpBinHeadersResponse
import io.ktor.client.HttpClient
import io.ktor.client.call.body
import io.ktor.client.request.get
import me.tatarka.inject.annotations.Inject
import software.amazon.lastmile.kotlin.inject.anvil.AppScope
import software.amazon.lastmile.kotlin.inject.anvil.ContributesBinding
import software.amazon.lastmile.kotlin.inject.anvil.SingleIn

@SingleIn(AppScope::class)
@ContributesBinding(AppScope::class, boundType = PingApiClient::class)
@Inject
class RemotePingApiClient(
    private val httpClient: HttpClient,
) : PingApiClient {

    override suspend fun getHeaders(authMode: AuthMode): Map<String, String> =
        httpClient
            .get("https://httpbin.org/headers") {
                attributes.put(AuthModeAttributeKey, authMode)
            }
            .body<HttpBinHeadersResponse>()
            .headers
}
